import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    babyEvaluationSheet (params) {
        return httpTool.fetchPost(apiConst.babyEvaluationSheetUrl,params)
    },
    setBabyEvaluationSheet (params,files) {
        return httpTool.fetchPostFile(apiConst.setBabyEvaluationSheetUrl,params,files)
    },
    getBabeMedicationList (params) {
        return httpTool.fetchPost(apiConst.getBabeMedicationListUrl,params)
    },
    addBabeMedicationList (params) {
        return httpTool.fetchPost(apiConst.addBabeMedicationListUrl,params)
    },
    getBabeSignList (params) {
        return httpTool.fetchPost(apiConst.getBabeSignListUrl,params)
    },
    addBabeSign (params) {
        return httpTool.fetchPost(apiConst.addBabeSignUrl,params)
    },
    getBreastMilkRecored (params) {
        return httpTool.fetchPost(apiConst.getBreastMilkRecoredUrl,params)
    },
    addBreastMilk (params) {
        return httpTool.fetchPost(apiConst.addBreastMilkUrl,params)
    },
    getBabeFeedRecored (params) {
        return httpTool.fetchPost(apiConst.getBabeFeedRecoredUrl,params)
    },
    addBabeFeedRecored (params) {
        return httpTool.fetchPost(apiConst.addBabeFeedRecoredUrl,params)
    }
}


// WEBPACK FOOTER //
// ./src/service/api/repository/babyLive-api.js